import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const igPostsFields = `
  _id,
  _type,
  title,
  profileName,
  profileDescription,
  profileImage {
    ${imageFields}
  },
  limit
`

export const IG_POSTS_QUERY = defineQuery(/* groq */ `
  *[_type == "ig-posts"][0]{
    ${igPostsFields}
  }
`)
